module.exports = __webpack_public_path__ + "img/rosanna.5b20dfac.png";